import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CORE_QUESTIONS } from '../data/quizData';
import { QuestionCard } from '../components/QuestionCard';
import { ProgressBar } from '../components/ui/ProgressBar';
import { encodeQuizData } from '../utils/helpers';
import { AnimatePresence } from 'framer-motion';
import { Footer } from '../components/Footer';

export const CreateFlow = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const creatorName = location.state?.creatorName || "Player";
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [isFinishing, setIsFinishing] = useState(false);

  const handleAnswer = (optionIndex) => {
    const newAnswers = [...answers, optionIndex];
    setAnswers(newAnswers);

    if (currentIndex < CORE_QUESTIONS.length - 1) {
      setTimeout(() => {
        setCurrentIndex(prev => prev + 1);
      }, 400);
    } else {
      setIsFinishing(true);
      const encodedData = encodeQuizData(creatorName, newAnswers);
      setTimeout(() => {
        navigate('/dashboard', { 
          state: { creatorName, answers: newAnswers, shareCode: encodedData } 
        });
      }, 800);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#012b58]">
      <div className="flex-1 flex flex-col p-6 max-w-2xl mx-auto w-full">
        <div className="pt-8 pb-12">
          <ProgressBar current={isFinishing ? CORE_QUESTIONS.length : currentIndex} total={CORE_QUESTIONS.length} />
        </div>

        <div className="flex-1 flex flex-col justify-center relative">
          <AnimatePresence mode="wait">
            {!isFinishing && (
              <QuestionCard 
                key={currentIndex}
                question={CORE_QUESTIONS[currentIndex]}
                currentIndex={currentIndex}
                total={CORE_QUESTIONS.length}
                onSelect={handleAnswer}
              />
            )}
            
            {isFinishing && (
              <div className="text-center text-white">
                <h2 className="text-2xl font-bold mb-2">Creating your profile...</h2>
                <div className="w-8 h-8 border-4 border-[#0094f7] border-t-transparent rounded-full animate-spin mx-auto mt-4" />
              </div>
            )}
          </AnimatePresence>
        </div>
      </div>
      <Footer />
    </div>
  );
};